import $ from 'jquery';

export default function appModule() {
  const appElement = $('#app');
  if (appElement.length) {
    return import(/* webpackChunkName: "app" */ '../app')
      .then(({ default: App }) => {
        const app = new App();
        return app;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
